import ReactGA from "react-ga";

const useAnalyticsEventTracker = (category = "dashboard") => {
  const eventTracker = (action = "create exercise", label = "new exercise") => {
    ReactGA.event({ category, action, label });
  };
  return eventTracker;
};
export default useAnalyticsEventTracker;
